import { jsx as _jsx } from "react/jsx-runtime";
// Component.
// -----------------------------------------------------------------------------
// Its only function is to render the 'thead' node.
export const BaseTableHead = ({ children }) => {
    return (_jsx("thead", { children: _jsx("tr", { children: children }) }));
};
//# sourceMappingURL=BaseTableHead.js.map